import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken, user_location, season_start, season_end } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';
import $ from "jquery";
import Swal from 'sweetalert2';
const ProductionDailyReports = () => {
  const [menu, setMenu] = useState(false);
  const [permission, setPermission] = useState({});
  const [dailyreports, setDailyreports] = useState([]);
  const [locationlist, setLocationlist] = useState([]);
  const [productnameLists, setproductnameLists] = useState([]);

  useEffect(() => {
    setPermission(FindModuleById(461));
    console.log(permission);

    axios.post("/daily-report/listing-new", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } })
      .then(res => { if (res.data.code === 200) setDailyreports(res.data.data.daily_reports); })
      .catch(console.log);

  }, []);
  const [formData, setFormData] = useState({
    startDate: season_start || '',
    endDate: season_end || '',
    //location:  '',  // ✅ Set user_location on initial load
    product: 1,
  });


  useEffect(() => {
    axios.get("/helpers/loading-locations", {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;

          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));

          setLocationlist(emp_statusList);

          setFormData(f => ({ ...f, location: user_location }));

        }
      })
      .catch(console.log);
  }, []);
  useEffect(() => {


    axios.post(
      "/products/listing-groupby",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          if (productslisting.length) {
            //const first = productslisting[0].value;
            setFormData(f => ({ ...f, product: 1 }));
          }

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, []);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const ShiftDateCell = ({ row }) => (
    <a href={`/dailyreports-view/${row.original.shift_date}_${row.original.shift}_${row.original.location}_${row.original.productname}`}>
      {row.original.shift_date}
    </a>
  );

  // ✅ Add PropTypes validation
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        shift: PropTypes.string.isRequired,
        productname: PropTypes.string.isRequired,

      }).isRequired,
    }).isRequired,
  };

  const ShiftCell = ({ row }) => (
    <a href={`/dailyreports-view/${row.original.shift_date}_${row.original.shift}_${row.original.location}_${row.original.productname}`}>
      {row.original.shift}
    </a>
  );

  // ✅ Add PropTypes validation
  ShiftCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        shift: PropTypes.string.isRequired,
        productname: PropTypes.string.isRequired,

      }).isRequired,
    }).isRequired,
  };

  const locationCell = ({ row }) => (
    <a href={`/dailyreports-view/${row.original.shift_date}_${row.original.shift}_${row.original.location}_${row.original.productname}`}>
      {row.original.location_name}
    </a>
  );

  // ✅ Add PropTypes validation
  locationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        location_name: PropTypes.string,
        shift: PropTypes.string.isRequired,
        productname: PropTypes.string.isRequired,

      }).isRequired,
    }).isRequired,
  };

  const productCell = ({ row }) => (
    <a href={`/dailyreports-view/${row.original.shift_date}_${row.original.shift}_${row.original.location}_${row.original.productname}`}>
      {row.original.productname}
    </a>
  );

  // ✅ Add PropTypes validation
  productCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        location_name: PropTypes.string,
        shift: PropTypes.string.isRequired,
        productname: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };


  
  
  const updateDate = async (id,type) =>{
  
  
  
    //  const showDateInputAlert = async () => {
        const { value: date } = await  Swal.fire({
          title: 'Update Production Manager',
          html: '<input type="type" id="datePicker" class="swal2-input">',
          showCancelButton: true,
          confirmButtonText: 'Update',
          cancelButtonText: 'Cancel',
          customClass: "swal-orders",
          preConfirm: () => {
            return document.getElementById('datePicker').value;
          }
        });
       
        if (date) {
          // Do something with the selected date
          console.log('Selected date:', date);
              axios.get(`/daily-report/update-production-manager/${id}/${date}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                
                if (response.data.code === 200) {
                  $("#button-"+type+"-"+id).text(response.data.data.date);
                  Swal.fire(
                    'Changed!',
                    'Production Manager Updated Successfully.',
                    'success'
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
        }
  
  }
     const ProductionDateCell = ({ row, permission, updateDate }) => {
      const { original } = row;
    
      return (
        <div>
          {permission?.update === 1 ? (
            <button
              className="btn btn-primary btn-block"
              id={`button-all-${original.id}`}
              onClick={() => updateDate(original.id, 'all')}
            >
              {original.production_manager ?? 'Update'}
            </button>
          ) : (
            <span>{original.production_manager ?? 'N/A'}</span>
          )}
        </div>
      );
    };
    
    
    // ✅ Define PropTypes
    ProductionDateCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          production_manager: PropTypes.string,
        }).isRequired,
      }).isRequired,
      permission: PropTypes.shape({
        update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      updateDate: PropTypes.func.isRequired,
    };

  const columnss = [
    {
      header: 'Shift Date',
      accessorFn: (row) => `${row.shift_date} `,
      Cell: ShiftDateCell,
    },
    {
      header: 'Shift',
      accessorFn: (row) => `${row.shift} `,
      Cell: ShiftCell,
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name} `,
      Cell: locationCell,
    },
    {
      header: 'Product',
      accessorFn: (row) => `${row.productname} `,
      Cell: productCell,
    }, 
    {
        header: 'Production Manager',
        accessorFn: (row) => row.production_manager || '',
        Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      },
  ];


  console.log(locationlist);

  console.log(productnameLists);
  console.log(dailyreports);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Daily Reports</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Daily Reports</li>
                </ul>
              </div>
              <div className="col-auto">


              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {permission && permission.list === 1 && (
                    <div className="table-responsive">
                      <MaterialReactTable
                        columns={columnss}
                        data={dailyreports}
                        enableColumnOrdering
                        enablePinning
                        enablePagination
                        initialState={{ pagination: { pageSize: 10, pageIndex: 0 } }}
                        muiPaginationProps={{
                          rowsPerPageOptions: [10, 50, 100, { label: 'All', value: dailyreports.length }],
                          showFirstButton: true,
                          showLastButton: true,
                        }}
                        paginationDisplayMode="pages"
                      />
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductionDailyReports;
